import React, { FC } from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Button, { BUTTON_TYPES, BUTTON_WIDTHS } from 'buyside/components/presentation/Button/button';
import CurrentEmployer from 'buyside/components/presentation/JoinCapIntroPage/Hero/currentEmployer';
import Link from 'buyside/components/presentation/Link/link';
import LoadingSpinner from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';

import SZLogoIcon from 'buyside/svgs/logo_white.svg';

import { profileUrl } from 'buyside/util/urlHelper';

import { useJoinCapIntroCurrentUserQuery } from 'interfaces/graphql-typings';

import styles from './heroStyles.scss';

const Hero: FC<{
  features: { icon: IconProp; title: string; description: string }[];
}> = ({ features }) => {
  const { data, error, loading } = useJoinCapIntroCurrentUserQuery();

  if (error) throw error;

  const { currentEmployers, profile } = data?.currentUser || {};

  return (
    <div className={styles.hero}>
      <div className={styles.heroLeftColumn}>
        <div className={styles.heroLeftColumnTitle}>
          <h1>
            <SZLogoIcon /> Cap Intro Platform
          </h1>
          <h3>Direct Access to Hundreds of Active Institutional Allocators</h3>
        </div>
        <div className={styles.heroLeftColumnActions}>
          {loading ? (
            <LoadingSpinner />
          ) : (
            <>
              {currentEmployers?.length === 0 ? (
                <>
                  <Button
                    text="Update Your Work Experience"
                    type={BUTTON_TYPES.PRIMARY}
                    url={profile ? profileUrl(profile.id) : '#'}
                    width={BUTTON_WIDTHS.FULL}
                  />
                  <p>
                    To qualify for Cap Intro, please update your work experience to reflect your
                    current employment. After updating, revisit{' '}
                    <Link to="/pro/cap-intro/join">this page</Link> to create and submit your fund
                    profile for review.
                  </p>
                </>
              ) : (
                currentEmployers?.map(currentEmployer => (
                  <CurrentEmployer
                    key={`${currentEmployer.name}-current-employer`}
                    {...currentEmployer}
                  />
                ))
              )}
            </>
          )}
        </div>
      </div>
      <div className={styles.heroRightColumn}>
        {features.map(({ description, icon, title }) => (
          <div key={title} className={styles.heroRightColumnItem}>
            <h3>
              <FontAwesomeIcon icon={icon} />
              {title}
            </h3>
            <p>{description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Hero;
